import last from 'lodash/last';
import first from 'lodash/first';
import { isOfType } from '../../../../ts-utils';
export const getNextChunkState = (state) => {
    const { nextChunkState } = state.topLevelCommentList;
    const lastChunk = lastFetchedChunk(state.topLevelCommentList.chunks);
    if (!lastChunk || !lastChunk.nextCursor) {
        return { type: 'NONE' };
    }
    return nextChunkState.type === 'IDLE'
        ? {
            type: 'HAS',
            cursor: lastChunk.nextCursor,
        }
        : {
            type: 'PENDING',
        };
};
export const getPrevChunkState = (state) => {
    const { prevChunkState } = state.topLevelCommentList;
    const firstChunk = firstFetchedChunk(state.topLevelCommentList.chunks);
    if (!firstChunk || !firstChunk.previousCursor) {
        return { type: 'NONE' };
    }
    return prevChunkState.type === 'IDLE'
        ? {
            type: 'HAS',
            cursor: firstChunk.previousCursor,
        }
        : {
            type: 'PENDING',
        };
};
// Replies are always sorted
// Next === Older replies
export const getNextReplyChunkState = (repliesState) => {
    if (!repliesState) {
        return { type: 'NONE' };
    }
    const { nextChunkState, chunks = [] } = repliesState;
    const lastChunk = last(chunks.filter(isOfType(['FETCHED', 'INITIAL'])));
    if (!lastChunk || !lastChunk.nextCursor) {
        return { type: 'NONE' };
    }
    return nextChunkState.type === 'IDLE'
        ? { type: 'HAS', cursor: lastChunk.nextCursor }
        : { type: 'PENDING' };
};
// Prev === Newer replies
export const getPrevReplyChunkState = (repliesState) => {
    if (!repliesState) {
        return { type: 'NONE' };
    }
    const { prevChunkState, chunks = [] } = repliesState;
    const firstChunk = first(chunks.filter(isOfType(['FETCHED', 'INITIAL'])));
    if (!firstChunk || !firstChunk.previousCursor) {
        return { type: 'NONE' };
    }
    return prevChunkState.type === 'IDLE'
        ? {
            type: 'HAS',
            cursor: firstChunk.previousCursor,
        }
        : { type: 'PENDING' };
};
const lastFetchedChunk = (chunks) => last(chunks.filter((c) => c.type === 'FETCHED'));
const firstFetchedChunk = (chunks) => first(chunks.filter((c) => c.type === 'FETCHED'));
//# sourceMappingURL=comments-paging-selectors.js.map